import * as React from 'react';
import {
  resolveDashboardCapability,
  type CapabilityInput,
  type DashboardCapability,
  type DashboardSourceKey,
} from '@/lib/dashboard/capability';

export const DashboardCapabilityContext = React.createContext<CapabilityInput | null>(null);

export function useWidgetCapability(
  sources: readonly DashboardSourceKey[] | undefined
): DashboardCapability | null {
  const snapshot = React.useContext(DashboardCapabilityContext);
  return React.useMemo(() => {
    if (!snapshot || !sources || sources.length === 0) return null;
    return resolveDashboardCapability(sources, snapshot);
  }, [snapshot, sources]);
}
